"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.WizardStep = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classNames = _interopRequireDefault(require("../../util/classNames"));

require("./WizardProgress.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var WizardProgressBar = function WizardProgressBar(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-wizard-progress"
  }, children);
};

WizardProgressBar.propTypes = {};
var _default = WizardProgressBar;
exports["default"] = _default;

var WizardStep = function WizardStep(_ref2) {
  var id = _ref2.id,
      active = _ref2.active,
      completed = _ref2.completed,
      disabled = _ref2.disabled,
      optional = _ref2.optional,
      captionOptional = _ref2.captionOptional,
      onClick = _ref2.onClick,
      children = _ref2.children;
  var classes = (0, _classNames["default"])({
    completed: completed,
    active: active,
    disabled: disabled,
    optional: optional
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'gcl-wizard-step ' + classes
  }, optional && /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-wizard-step-caption-optional"
  }, captionOptional), /*#__PURE__*/_react["default"].createElement("button", {
    className: "gcl-step-btn",
    onClick: onClick,
    disabled: active || disabled
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon selected"
  })), /*#__PURE__*/_react["default"].createElement("label", null, children));
};

exports.WizardStep = WizardStep;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/WizardProgress/WizardProgress.js
// module id = 1937
// module chunks = 0